var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-select',{attrs:{"select-list":_vm.dropdownList.SmluvpartnerPzn,"value":_vm.SmluvpartnerPzn,"label-key":"SMLUVPARTNER_ID","clearable":false},on:{"update:value":function($event){_vm.SmluvpartnerPzn=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }